import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import order from '../order.pdf';
import { MENTORS_URL } from '../router/urls';
import { getForms, getFlows } from '../actions';

import RequestList from '../components/RequestList';
import RequestCreate from '../components/RequestCreate';

class MainPage extends React.Component {
  componentDidMount() {
    this.props.getForms();
  }

  render = () => (
    <div className="content">
      <div className="d-sm-block d-lg-flex justify-content-between align-items-start">
        <h2 className="content__title">Консультационно-менторский сервис</h2>
        {(this.props.user.is_mentor || this.props.user.is_specialist) && (
          <Link className="btn btn-sm btn-default" to={MENTORS_URL}>
            Перейти в кабинет ментора
          </Link>
        )}
      </div>
      <div className="line" />
      {this.props.mode === 'working' && this.props?.user?.isAccess && (
        <div className="container-fluid nopad">
          <h4>Оформление заявки на получение консультации</h4>
          <RequestCreate />
        </div>
      )}
      {this.props.mode === 'suspended' && (
        <div className="container-fluid nopad">
          <p style={{ color: 'red' }}>Приём заявок временно приостановлен</p>
          <a className="btn-link" target="_blank" href={order}>
            Приказ от 19.01.2021 № 3-Пр {'"'}О приостановлении приема заявок на
            получение минигрантов{'"'}
          </a>
        </div>
      )}
      <div className="line" />
      <div className="container-fluid nopad">
        <h4>Все заявки</h4>
        <RequestList />
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    mode: state.forms.mode,
    user: state.forms.user || {},
  };
}

const mapDispatchToProps = {
  getForms,
  getFlows,
};

export default connect(mapStateToProps, mapDispatchToProps)(MainPage);
